import React, { FC } from "react";
import { getImageUrl } from "src/utils/getImageUrl";
import { Avatar } from "src/components/Avatar";
import { IClone } from "src/@types/clones";
import { Sizes } from "src/@types/sizes";
import { ReactComponent as ApprovalHandIcon } from "src/assets/icons/approval-hand.svg";
import { Location } from "./Location";
import { Contacts } from "./Contacts";
import { CloneFeatures } from "./CloneFeatures";
import { ActionButtons } from "./ActionButtons";
import { Show } from "src/components/PrivateRoute/Show";
import { ONLY_FOR } from "src/components/PrivateRoute/types";
import { Roles } from "src/@types/users";

interface Props {
  clone: IClone;
  isFavorite: boolean;
  setIsFavorite: (isFavorite: boolean) => void;
}

export const MainInfoCard: FC<Props> = ({
  clone: {
    main_photo,
    company_name,
    logo,
    host,
    website,
    information_sold,
    id,
    is_host,
    is_active_deal,
  },
  isFavorite,
  setIsFavorite,
}) => {
  // there have been role naming changes: Agent equals Broker
  const displayedRole = host.role === Roles.AGENT ? "broker" : Roles.OWNER;

  return (
    <div className="flex flex-col xl:flex-row gap-5 bg-purple-lighter md:p-10 rounded-20">
      <div className="w-full xl:max-w-130">
        <img
          className="xs:h-125 xl:h-full object-contain w-full rounded-20"
          src={getImageUrl(main_photo)}
          alt={company_name}
        />
      </div>

      <div className="flex flex-col gap-5 p-3 md:p-0 w-full">
        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            <Avatar
              sizeVariant={Sizes.S}
              avatarUrl={getImageUrl(logo)}
              altText={company_name}
            />

            <div className="text-purple-base text-lg">
              <p>{company_name}</p>
              <div className="flex items-center gap-2">
                <ApprovalHandIcon />
                <p>{displayedRole}</p>
              </div>
            </div>
          </div>

          {/* <StarRating
            rating={rating}
            titleClassName="text-purple-base text-base font-semibold"
            className="gap-5"
            isShownNumberValue
            isShownTitle
          /> */}

          <Location {...host.location} />
        </div>

        <Contacts
          profileSlug={host.slug}
          profileId={host.id}
          profile={`${host.first_name} ${host.last_name}`}
          address={host.company_address}
          phone={host.phone_number}
          website={website}
        />

        <div className="flex justify-between">
          {/* <SocialRatings /> */}
          <CloneFeatures features={information_sold} />
        </div>

        <Show onlyFor={ONLY_FOR.AGENT}>
          <ActionButtons
            id={id}
            isFavorite={isFavorite}
            setIsFavorite={setIsFavorite}
            isHost={is_host}
            isActiveDeal={is_active_deal}
          />
        </Show>
      </div>
    </div>
  );
};
